webpackJsonp([62],{

/***/ "4iGy":
/***/ (function(module, exports, __webpack_require__) {

var SectionHorizontalImageText = (function () {
    function SectionHorizontalImageText() {
    }
    return SectionHorizontalImageText;
}());
angular.module('animatronApp.sectionHorizontalImageText', []).component('sectionHorizontalImageText', {
    bindings: {
        ltTitle: '<',
        text: '<',
        buttons: '<',
        imageUrl: '<',
    },
    controller: SectionHorizontalImageText,
    templateUrl: __webpack_require__("Ru63")
});


/***/ }),

/***/ "Ru63":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-horizontal-image-text_609bd070afd512aefd90cd9dfbe1415f.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/62-28dc41a6a889e793a2e2.min.js